/* Fashion CITY — 견적 요청 마법사
   상품 → 스타일·색상 → 제작 방식 → 문구/글씨체/색/위치/크기 → 수량·사이즈 → 연락처
   고르는 대로 왼쪽 미리보기에 바로 반영되고, 다 채우면 우리 이메일로 정리돼서 옵니다.

   ★ 스타일·색상 사진·작업 위치·사이즈는 상품 페이지와 똑같은 파일을 씁니다.
       window.FCPO_STYLES            (fc-po-colors / cap / sweatshirt / hoodie / tee / bag .js)
       window.FCPO_PLACE_BY_HANDLE   작업 위치
       window.FCPO_SIZERUN           옷 사이즈 목록
     → 상품 페이지를 고치면 여기도 같이 바뀝니다. 따로 손댈 필요 없습니다.

   자료가 없는 상품은 예전처럼 일러스트로 나옵니다.
       옷 모양 : assets/fc-shapes.js
       색 목록 : assets/fc-colors.js
*/
(function () {
  'use strict';

  var cfgEl = document.getElementById('fcq-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var PRODUCTS = CFG.products || [];
  if (!PRODUCTS.length) return;

  var C = window.FC_COLORS || {};
  var SHAPES = window.FC_SHAPES || {};
  var NL = String.fromCharCode(10);

  var FONTS = [
    { n: 'Classic Serif', f: "Georgia,'Times New Roman',serif", w: 400, up: false },
    { n: 'Clean Sans',    f: "'Helvetica Neue',Helvetica,Arial,sans-serif", w: 600, up: false },
    { n: 'Bold Block',    f: "'Arial Black',Impact,sans-serif", w: 900, up: true },
    { n: 'Script',        f: "'Snell Roundhand','Brush Script MT','Segoe Script',cursive", w: 400, up: false },
    { n: 'Collegiate',    f: "Georgia,'Times New Roman',serif", w: 700, up: true },
    { n: 'Typewriter',    f: "'Courier New',Courier,monospace", w: 700, up: false }
  ];
  var REC = 'Recommend one for me';

  function rgbOf(c, m, y, k) {
    var f = function (v) { return Math.round(255 * (1 - v / 100) * (1 - k / 100)); };
    return 'rgb(' + f(c) + ',' + f(m) + ',' + f(y) + ')';
  }
  function cmykLabel(c, m, y, k) {
    return 'C' + Math.round(c) + ' M' + Math.round(m) + ' Y' + Math.round(y) + ' K' + Math.round(k);
  }
  var CMYK = (function () {
    var out = [], t, h, n;
    var HUES = C.HUES || [], TINTS = C.TINTS || [1], NEU = C.NEUTRALS || [];
    for (t = 0; t < TINTS.length; t++) {
      for (h = 0; h < HUES.length; h++) {
        var H = HUES[h], s = TINTS[t];
        out.push([cmykLabel(H[1] * s, H[2] * s, H[3] * s, H[4] * s),
                  rgbOf(H[1] * s, H[2] * s, H[3] * s, H[4] * s)]);
      }
    }
    for (n = 0; n < NEU.length; n++) {
      out.push([cmykLabel(NEU[n][0], NEU[n][1], NEU[n][2], NEU[n][3]),
                rgbOf(NEU[n][0], NEU[n][1], NEU[n][2], NEU[n][3])]);
    }
    return out;
  })();

  var state = {
    pi: -1, product: null,
    si: 0,
    gcolor: '', gcolorCss: '', gImg: '', gImgBack: '',
    method: '',
    mode: 'text', text: '', font: REC,
    tcolor: '', tcolorCss: '',
    spot: 0,
    artSize: 1,
    sizes: {},
    pieces: 0
  };

  var root = document.querySelector('[data-fcq]');
  if (!root) return;
  var form = root.closest('form');

  function q(sel) { return root.querySelector(sel); }
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function rgbParts(css) {
    var m = String(css).match(/([0-9]+)[^0-9]+([0-9]+)[^0-9]+([0-9]+)/);
    return m ? [+m[1], +m[2], +m[3]] : [0, 0, 0];
  }
  function darken(css, f) {
    var p = rgbParts(css);
    return 'rgb(' + Math.round(p[0] * f) + ',' + Math.round(p[1] * f) + ',' + Math.round(p[2] * f) + ')';
  }
  function lum(css) {
    var p = rgbParts(css);
    return (0.299 * p[0] + 0.587 * p[1] + 0.114 * p[2]) / 255;
  }
  function thumb(u, w) {
    if (!u) return '';
    if (String(u).indexOf('cdn.shopify.com') < 0) return u;
    return u + (String(u).indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200);
  }

  // ---------- 상품 페이지와 공유하는 자료 ----------
  function styleSet() {
    var h = state.product && state.product.handle;
    return (h && window.FCPO_STYLES && window.FCPO_STYLES[h]) || null;
  }
  function styleList() {
    var s = styleSet();
    return (s && s.styles) || [];
  }
  function curStyle() {
    var l = styleList();
    if (!l.length) return null;
    if (state.si < 0 || state.si >= l.length) state.si = 0;
    return l[state.si];
  }
  function colorList() {
    var st = curStyle();
    return (st && st.colors) || [];
  }
  function realPlaces() {
    var st = curStyle();
    if (st && st.place) return [st.place];
    var h = state.product && state.product.handle;
    if (h && window.FCPO_PLACE_BY_HANDLE && window.FCPO_PLACE_BY_HANDLE[h]) {
      return window.FCPO_PLACE_BY_HANDLE[h];
    }
    return null;
  }
  function usePhotos() { return colorList().length > 0; }
  function productImg(p) {
    if (p.img) return p.img;
    var s = window.FCPO_STYLES && window.FCPO_STYLES[p.handle];
    var st = s && s.styles && s.styles[0];
    var c = st && st.colors && st.colors[0];
    return c ? c[1] : '';
  }

  function methodKey(title) {
    var t = String(title).toLowerCase();
    if (t.indexOf('puff') > -1) return 'puff';
    if (t.indexOf('print') > -1 || t.indexOf('color') > -1) return 'print';
    if (t.indexOf('patch') > -1) return 'patch';
    return 'emb';
  }
  function paletteFor(title) {
    var k = methodKey(title);
    var emb = window.FCPO_EMB || C.EMB || [];
    var puff = window.FCPO_PUFF || C.PUFF || [];
    if (k === 'puff') return { list: puff, chart: false, label: 'Puff color' };
    if (k === 'print') return { list: CMYK, chart: true, label: 'Print color' };
    if (k === 'patch') return { list: emb, chart: false, label: 'Patch color' };
    return { list: emb, chart: false, label: 'Thread color' };
  }
  function fontOf(name) {
    for (var i = 0; i < FONTS.length; i++) if (FONTS[i].n === name) return FONTS[i];
    return FONTS[1];
  }
  var SIZE_WORDS = ['Small', 'Medium', 'Large'];
  function shape() { return SHAPES[state.product && state.product.shape] || SHAPES.tee; }
  function artSizeLabel(sp, i) {
    var inches = (sp.sizes || [2, 3, 4])[i];
    var pretty = (inches % 1 === 0) ? inches : inches.toFixed(1);
    return SIZE_WORDS[i] + ' · about ' + pretty + '"';
  }
  function norm(s) { return String(s).toLowerCase().split(' ').join('').split('-').join(''); }
  function findShot() {
    var list = CFG.shots || [];
    if (!state.product || !state.gcolor) return '';
    var h = norm(state.product.handle), c = norm(state.gcolor);
    for (var i = 0; i < list.length; i++) {
      if (!list[i].img) continue;
      if (norm(list[i].handle) !== h) continue;
      if (norm(list[i].color) !== c) continue;
      return list[i].img;
    }
    return '';
  }
  function spots() {
    var rp = realPlaces();
    if (rp && rp.length) return rp;
    return (shape() && shape().spots) || [{ v: 'Front', x: 100, y: 110, w: 60 }];
  }

  // ---------- 사이즈 ----------
  var SIZE_RUN = ['S', 'M', 'L', 'XL', '2XL', '3XL'];
  function isApparelShape() {
    var s = state.product && state.product.shape;
    return s === 'tee' || s === 'crew' || s === 'hoodie';
  }
  function sizeList() {
    var h = state.product && state.product.handle;
    var l = h && window.FCPO_SIZERUN_BY_HANDLE && window.FCPO_SIZERUN_BY_HANDLE[h];
    if (l && l.length) return l;
    if (!isApparelShape()) return null;
    if (window.FCPO_SIZERUN && window.FCPO_SIZERUN.apparel) return window.FCPO_SIZERUN.apparel;
    return SIZE_RUN;
  }
  function isApparel() { return !!sizeList(); }

  // ---------- 디자인 링크 ----------
  function designLink() {
    if (!state.product) return '';
    var sl = sizeList() || [], run = [], i;
    for (i = 0; i < sl.length; i++) run.push(state.sizes[sl[i]] || 0);
    var parts = [
      String(state.pi), state.gcolor, state.method, state.mode, state.text,
      state.font, state.tcolor, String(state.spot), String(state.artSize),
      run.join('.'), String(state.pieces || 0), String(state.si)
    ];
    for (i = 0; i < parts.length; i++) parts[i] = encodeURIComponent(parts[i]);
    return location.origin + location.pathname + '?fcq=' + parts.join(',') + '#' + (CFG.anchor || 'get-a-quote');
  }
  function applyLink() {
    var m = location.search.match(/[?&]fcq=([^&]*)/);
    if (!m || !m[1]) return false;
    var p = m[1].split(','), i;
    for (i = 0; i < p.length; i++) { try { p[i] = decodeURIComponent(p[i]); } catch (e) { p[i] = ''; } }
    var pi = parseInt(p[0], 10);
    if (isNaN(pi) || !PRODUCTS[pi]) return false;
    state.pi = pi;
    state.product = PRODUCTS[pi];
    state.si = parseInt(p[11], 10) || 0;
    state.gcolor = p[1] || '';
    state.gcolorCss = cssOf(C.GARMENT || [], state.gcolor);
    state.method = p[2] || (state.product.methods || [])[0] || '';
    state.mode = p[3] === 'logo' ? 'logo' : 'text';
    state.text = p[4] || '';
    state.font = p[5] || REC;
    state.tcolor = p[6] || '';
    state.tcolorCss = cssOf(paletteFor(state.method).list, state.tcolor);
    state.spot = parseInt(p[7], 10) || 0;
    state.artSize = parseInt(p[8], 10);
    if (isNaN(state.artSize)) state.artSize = 1;
    var sl = sizeList() || SIZE_RUN;
    var run = String(p[9] || '').split('.');
    for (i = 0; i < sl.length; i++) state.sizes[sl[i]] = parseInt(run[i], 10) || 0;
    state.pieces = parseInt(p[10], 10) || 0;
    return true;
  }
  function cssOf(list, name) {
    for (var i = 0; i < list.length; i++) if (list[i][0] === name) return list[i][1];
    return '';
  }

  // ---------- 화면 조각 ----------
  function card(name, value, inner, checked, cls) {
    var id = 'fcq-' + name + '-' + String(value).replace(/[^a-zA-Z0-9]+/g, '');
    return '<span class="fcq__opt ' + (cls || '') + '">' +
      '<input type="radio" name="' + name + '" id="' + id + '" value="' + esc(value) + '"' +
      (checked ? ' checked' : '') + '>' +
      '<label for="' + id + '">' + inner + '</label></span>';
  }
  function chip(name, value, label, checked) {
    return card(name, value, esc(label), checked, 'fcq__opt--chip');
  }
  function swatch(name, value, css, showName, checked, cls) {
    return card(name, value,
      '<span class="fcq__sw" style="background:' + esc(css) + '"></span>' +
      (showName ? '<span class="fcq__swn">' + esc(value) + '</span>' : ''),
      checked, 'fcq__opt--sw ' + (cls || ''));
  }
  function photoCard(value, img, back, checked) {
    var id = 'fcq-gcolor-' + String(value).replace(/[^a-zA-Z0-9]+/g, '');
    return '<span class="fcq__opt fcq__opt--ph">' +
      '<input type="radio" name="fcq-gcolor" id="' + id + '" value="' + esc(value) + '"' +
      ' data-img="' + esc(img) + '" data-img2="' + esc(back || '') + '"' +
      (checked ? ' checked' : '') + '>' +
      '<label for="' + id + '" title="' + esc(value) + '">' +
      '<img src="' + esc(thumb(img, 200)) + '" alt="' + esc(value) + '"></label></span>';
  }

  function renderProducts() {
    var h = '';
    for (var i = 0; i < PRODUCTS.length; i++) {
      var p = PRODUCTS[i];
      var im = productImg(p);
      h += card('fcq-product', String(i),
        (im ? '<img src="' + esc(thumb(im, 400)) + '" alt="">' : '<span class="fcq__noimg"></span>') +
        '<span class="fcq__pname">' + esc(p.title) + '</span>',
        state.pi === i, 'fcq__opt--card');
    }
    q('[data-fcq-products]').innerHTML = h;
  }

  function renderStyles() {
    var wrap = q('[data-fcq-styles]');
    if (!wrap) return;
    var sl = styleList();
    var s = styleSet();
    if (sl.length < 2) { wrap.innerHTML = ''; wrap.style.display = 'none'; return; }
    wrap.style.display = '';
    var h = '';
    for (var i = 0; i < sl.length; i++) h += chip('fcq-style', String(i), sl[i].n, state.si === i);
    wrap.innerHTML = h;
    if (s && s.styleLabel) wrap.setAttribute('aria-label', s.styleLabel);
  }

  function renderGarment() {
    var wrap = q('[data-fcq-gcolors]');
    if (!wrap) return;
    var list = colorList(), i;

    if (list.length) {
      var keep = -1;
      for (i = 0; i < list.length; i++) if (list[i][0] === state.gcolor) { keep = i; break; }
      if (keep < 0) keep = 0;
      state.gcolor = list[keep][0];
      state.gImg = list[keep][1];
      state.gImgBack = list[keep][2] || '';
      state.gcolorCss = '';
      var ph = '';
      for (i = 0; i < list.length; i++) {
        ph += photoCard(list[i][0], list[i][1], list[i][2], i === keep);
      }
      wrap.className = 'fcq__photos';
      wrap.innerHTML = ph;
      return;
    }

    state.gImg = '';
    state.gImgBack = '';
    var g = C.GARMENT || [], h = '';
    for (i = 0; i < g.length; i++) {
      h += swatch('fcq-gcolor', g[i][0], g[i][1], true, state.gcolor === g[i][0]);
    }
    wrap.className = 'fcq__swatches';
    wrap.innerHTML = h;
  }

  function renderMethods() {
    var ms = (state.product && state.product.methods) || [], h = '';
    for (var i = 0; i < ms.length; i++) h += chip('fcq-method', ms[i], ms[i], state.method === ms[i]);
    q('[data-fcq-methods]').innerHTML = h;
  }
  function renderFonts() {
    var h = '', i;
    for (i = 0; i < FONTS.length; i++) {
      h += card('fcq-font', FONTS[i].n,
        '<span class="fcq__fs" data-fcq-sample style="font-family:' + FONTS[i].f +
        ';font-weight:' + FONTS[i].w + (FONTS[i].up ? ';text-transform:uppercase' : '') + '">Your Text</span>' +
        '<span class="fcq__fn">' + esc(FONTS[i].n) + '</span>',
        state.font === FONTS[i].n, 'fcq__opt--font');
    }
    h += card('fcq-font', REC, '<span class="fcq__fs">&#9998;</span><span class="fcq__fn">Recommend one</span>',
      state.font === REC, 'fcq__opt--font');
    q('[data-fcq-fonts]').innerHTML = h;
  }
  function renderTextColors() {
    var pal = paletteFor(state.method);
    var wrap = q('[data-fcq-tcolors]');
    var lab = q('[data-fcq-tclabel]');
    if (lab) lab.textContent = pal.label;
    wrap.className = 'fcq__swatches' + (pal.chart ? ' fcq__chart' : '');
    var keep = -1, i;
    for (i = 0; i < pal.list.length; i++) if (pal.list[i][0] === state.tcolor) { keep = i; break; }
    if (keep < 0) keep = 0;
    if (pal.list.length) { state.tcolor = pal.list[keep][0]; state.tcolorCss = pal.list[keep][1]; }
    var h = '';
    for (i = 0; i < pal.list.length; i++) {
      h += swatch('fcq-tcolor', pal.list[i][0], pal.list[i][1], !pal.chart, i === keep);
    }
    wrap.innerHTML = h;
  }
  function renderSpots() {
    var sp = spots(), h = '';
    if (state.spot >= sp.length) state.spot = 0;
    for (var i = 0; i < sp.length; i++) h += chip('fcq-spot', String(i), sp[i].v, state.spot === i);
    q('[data-fcq-spots]').innerHTML = h;
    renderArtSizes();
  }
  function renderArtSizes() {
    var wrap = q('[data-fcq-artsizes]');
    if (!wrap) return;
    var sp = spots()[state.spot] || spots()[0];
    var h = '';
    for (var i = 0; i < 3; i++) h += chip('fcq-artsize', String(i), artSizeLabel(sp, i), state.artSize === i);
    wrap.innerHTML = h;
  }
  function totalQty() {
    var sl = sizeList();
    if (!sl) return state.pieces || 0;
    var t = 0;
    for (var i = 0; i < sl.length; i++) t += (state.sizes[sl[i]] || 0);
    return t;
  }
  function sizeBreakdown() {
    var sl = sizeList();
    if (!sl) return '';
    var out = [];
    for (var i = 0; i < sl.length; i++) {
      if (state.sizes[sl[i]]) out.push(sl[i] + ' ' + state.sizes[sl[i]]);
    }
    return out.join(' · ');
  }
  function renderQty() {
    var wrap = q('[data-fcq-qty]');
    if (!wrap) return;
    var sl = sizeList();
    var h = '', i;
    if (sl) {
      h += '<div class="fcq__sizes" style="grid-template-columns:repeat(' + sl.length + ',minmax(0,1fr))">';
      for (i = 0; i < sl.length; i++) {
        h += '<label class="fcq__size"><span>' + esc(sl[i]) + '</span>' +
          '<input type="number" min="0" step="1" inputmode="numeric" data-fcq-size="' + esc(sl[i]) +
          '" value="' + (state.sizes[sl[i]] || '') + '" placeholder="0"></label>';
      }
      h += '</div>';
    } else {
      h += '<div class="fcq__sizes fcq__sizes--one"><label class="fcq__size"><span>Pieces</span>' +
        '<input type="number" min="0" step="1" inputmode="numeric" data-fcq-pieces value="' +
        (state.pieces || '') + '" placeholder="0"></label></div>';
    }
    h += '<p class="fcq__total">Total <b data-fcq-total>0</b> pieces <em data-fcq-moq></em></p>';
    wrap.innerHTML = h;
    updateTotal();
  }
  function updateTotal() {
    var t = totalQty();
    var b = q('[data-fcq-total]');
    if (b) b.textContent = t;
    var moq = (state.product && state.product.moq) || 6;
    var e = q('[data-fcq-moq]');
    if (e) e.textContent = (t > 0 && t < moq) ? ('— minimum for this one is ' + moq) : '';
  }

  // ---------- 미리보기 ----------
  function mockPhoto() {
    if (usePhotos()) {
      var sp = spots()[state.spot] || spots()[0];
      if (sp && sp.view === 'back' && state.gImgBack) return state.gImgBack;
      if (state.gImg) return state.gImg;
    }
    return findShot();
  }

  function renderMock() {
    var box = q('[data-fcq-mock]');
    if (!box) return;
    var photo = mockPhoto();

    if (photo) {
      box.className = 'fcq__mock fcq__mock--photo';
      box.innerHTML = '<span class="fcq__phwrap">' +
        '<img class="fcq__phimg" src="' + esc(thumb(photo, 900)) + '" alt="">' +
        '<span class="fcq__ovt" data-fcq-ovt></span></span>';
      var im = box.querySelector('img');
      im.addEventListener('load', drawArt);
      drawArt();
      return;
    }

    box.className = 'fcq__mock';
    var sh = shape();
    if (!sh) { box.innerHTML = ''; return; }
    var col = state.gcolorCss || 'rgb(228,224,217)';
    var line = lum(col) < 0.28 ? 'rgba(255,255,255,.28)' : 'rgba(0,0,0,.22)';
    var body = '';
    for (var i = 0; i < sh.parts.length; i++) {
      var p = sh.parts[i];
      if (p.role === 'body') {
        body += '<path d="' + p.d + '" fill="' + col + '" stroke="' + line + '" stroke-width="1.6" stroke-linejoin="round"/>';
      } else if (p.role === 'shade') {
        body += '<path d="' + p.d + '" fill="' + darken(col, 0.88) + '" stroke="' + line + '" stroke-width="1.2" stroke-linejoin="round"/>';
      } else {
        body += '<path d="' + p.d + '" fill="none" stroke="' + line + '" stroke-width="1.4" stroke-linecap="round"/>';
      }
    }
    box.innerHTML = '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="mockup">' +
      body + '<g data-fcq-art></g></svg>';
    drawArt();
  }

  function drawArt() {
    var ov = q('[data-fcq-ovt]');
    if (ov) { drawArtPhoto(ov); return; }
    drawArtSvg();
  }

  function drawArtPhoto(t) {
    var wrap = t.parentNode;
    var img = wrap.querySelector('img');
    if (!img) return;
    var box = img.getBoundingClientRect();
    var W = box.width || wrap.getBoundingClientRect().width || 300;
    var H = box.height || W;
    var sp = spots()[state.spot] || spots()[0];
    var run = sp.sizes || [2, 3, 4];
    var ratio = run[state.artSize] / run[1];
    var wPct = sp.w * ratio;
    var hPct = (sp.h || 0) * ratio;
    var ink = state.tcolorCss || 'rgb(28,26,23)';
    var shadow = lum(ink) > 0.72 ? '0 0 2px rgba(0,0,0,.55)' : '0 1px 2px rgba(255,255,255,.35)';

    t.style.left = sp.x + '%';
    t.style.top = sp.y + '%';
    t.style.width = wPct + '%';
    t.style.color = ink;
    t.style.textShadow = shadow;
    t.style.transform = 'translate(-50%,-50%)';
    t.style.display = '';

    if (state.mode === 'logo') {
      t.className = 'fcq__ovt is-logo';
      t.textContent = 'YOUR LOGO';
      t.style.borderColor = ink;
      t.style.height = (hPct > 0 ? (H * hPct / 100) : (W * wPct / 100 * 0.55)) + 'px';
      t.style.fontFamily = '';
      t.style.fontWeight = '';
      t.style.textTransform = '';
      t.style.fontSize = Math.max(5, W * wPct / 100 / 8) + 'px';
      return;
    }

    var txt = state.text.trim();
    t.className = 'fcq__ovt';
    t.style.border = '0';
    t.style.height = 'auto';
    if (!txt) { t.textContent = ''; t.style.display = 'none'; return; }

    var fo = fontOf(state.font === REC ? 'Clean Sans' : state.font);
    t.style.fontFamily = fo.f;
    t.style.fontWeight = fo.w;
    t.style.textTransform = fo.up ? 'uppercase' : 'none';
    t.textContent = txt;
    t.style.fontSize = '100px';
    var natural = t.scrollWidth || 1;
    var target = W * wPct / 100;
    t.style.fontSize = Math.max(4, Math.min(220, 100 * target / natural)) + 'px';

    if (hPct > 0) {
      var targetH = H * hPct / 100;
      var rh = t.getBoundingClientRect().height || 1;
      var sy = targetH / rh;
      if (sy < 0.6) sy = 0.6;
      if (sy > 6) sy = 6;
      t.style.transform = 'translate(-50%,-50%) scaleY(' + sy + ')';
    }
  }

  function drawArtSvg() {
    var svg = q('[data-fcq-mock] svg');
    if (!svg) return;
    var g = svg.querySelector('[data-fcq-art]');
    if (!g) return;
    g.innerHTML = '';
    var sp = spots()[state.spot] || spots()[0];
    var ink = state.tcolorCss || 'rgb(28,26,23)';
    var run = sp.sizes || [2, 3, 4];
    var w = sp.w * (run[state.artSize] / run[1]);

    if (state.mode === 'logo') {
      var pad = w * 0.5;
      g.innerHTML = '<rect x="' + (sp.x - w / 2) + '" y="' + (sp.y - pad / 2) + '" width="' + w +
        '" height="' + pad + '" rx="2" fill="none" stroke="' + ink + '" stroke-width="1.4" stroke-dasharray="4 3"/>' +
        '<text x="' + sp.x + '" y="' + (sp.y + 2) + '" text-anchor="middle" fill="' + ink +
        '" font-family="Helvetica,Arial,sans-serif" font-size="6" font-weight="700" letter-spacing="1">YOUR LOGO</text>';
      return;
    }

    var txt = state.text.trim();
    if (!txt) return;
    var fo = fontOf(state.font === REC ? 'Clean Sans' : state.font);
    var t = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    t.setAttribute('x', sp.x);
    t.setAttribute('y', sp.y);
    t.setAttribute('text-anchor', 'middle');
    t.setAttribute('dominant-baseline', 'middle');
    t.setAttribute('fill', ink);
    t.setAttribute('font-family', fo.f);
    t.setAttribute('font-weight', fo.w);
    t.setAttribute('font-size', '20');
    t.textContent = fo.up ? txt.toUpperCase() : txt;
    g.appendChild(t);
    var len = 0;
    try { len = t.getComputedTextLength(); } catch (e) { len = 0; }
    if (len > 0) {
      var size = Math.max(2.5, Math.min(26, 20 * w / len));
      t.setAttribute('font-size', size);
    }
  }

  function summaryRows() {
    var sp = spots()[state.spot] || spots()[0];
    var st = curStyle();
    return [
      ['Product', state.product ? state.product.title : ''],
      ['Style', st ? (st.n + (st.sku ? ' (' + st.sku + ')' : '')) : ''],
      ['Product color', state.gcolor],
      ['Method', state.method],
      ['Artwork', state.mode === 'logo' ? 'My logo (we will email you for the file)' : 'Custom text'],
      ['Text', state.mode === 'logo' ? '' : state.text.trim()],
      ['Font', state.mode === 'logo' ? '' : state.font],
      ['Text color', state.tcolor],
      ['Placement', sp ? sp.v : ''],
      ['Size', sp ? artSizeLabel(sp, state.artSize) : ''],
      ['Quantity', totalQty() ? totalQty() + ' pcs' : ''],
      ['Sizes', sizeBreakdown()]
    ];
  }
  function syncOut() {
    var rows = summaryRows(), i;
    for (i = 0; i < rows.length; i++) {
      var input = root.querySelector('[data-fcq-out="' + rows[i][0] + '"]');
      if (input) { input.value = rows[i][1] || ''; input.disabled = !rows[i][1]; }
    }
    var lines = ['CUSTOM QUOTE REQUEST', ''];
    for (i = 0; i < rows.length; i++) if (rows[i][1]) lines.push(rows[i][0] + ': ' + rows[i][1]);
    var link = designLink();
    var dl = root.querySelector('[data-fcq-link]');
    if (dl) { dl.value = link; dl.disabled = !link; }
    if (link) lines.push('', 'See the design: ' + link);
    var body = root.querySelector('[data-fcq-body]');
    if (body) body.value = lines.join(NL);

    var ul = q('[data-fcq-summary]');
    if (ul) {
      var h = '';
      for (i = 0; i < rows.length; i++) {
        if (!rows[i][1]) continue;
        h += '<li><span>' + esc(rows[i][0]) + '</span><strong>' + esc(rows[i][1]) + '</strong></li>';
      }
      ul.innerHTML = h;
    }
  }

  var ORDER = ['product', 'gcolor', 'method', 'art', 'qty', 'contact'];
  function done(step) {
    if (step === 'product') return !!state.product;
    if (step === 'gcolor') return !!state.gcolor;
    if (step === 'method') return !!state.method;
    if (step === 'art') return state.mode === 'logo' || !!state.text.trim();
    if (step === 'qty') return totalQty() > 0;
    return true;
  }
  function refreshSteps() {
    var open = true;
    for (var i = 0; i < ORDER.length; i++) {
      var elx = q('[data-fcq-step="' + ORDER[i] + '"]');
      if (!elx) continue;
      elx.classList.toggle('is-open', open);
      elx.classList.toggle('is-done', done(ORDER[i]));
      if (open && !done(ORDER[i])) open = false;
    }
  }
  function reveal(step) {
    var elx = q('[data-fcq-step="' + step + '"]');
    if (!elx) return;
    var y = elx.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  root.addEventListener('change', function (e) {
    var n = e.target.name, v = e.target.value;
    if (n === 'fcq-product') {
      state.pi = parseInt(v, 10);
      state.product = PRODUCTS[state.pi];
      state.si = 0;
      state.gcolor = '';
      state.gImg = '';
      state.gImgBack = '';
      state.method = (state.product.methods && state.product.methods[0]) || '';
      state.spot = 0;
      state.sizes = {};
      renderStyles(); renderGarment(); renderMethods(); renderSpots();
      renderQty(); renderTextColors(); renderMock();
      refreshSteps(); syncOut(); reveal('gcolor');
      return;
    }
    if (n === 'fcq-style') {
      state.si = parseInt(v, 10) || 0;
      state.gcolor = '';
      state.spot = 0;
      renderGarment(); renderSpots(); renderMock();
      refreshSteps(); syncOut();
      return;
    }
    if (n === 'fcq-gcolor') {
      state.gcolor = v;
      if (e.target.hasAttribute('data-img')) {
        state.gImg = e.target.getAttribute('data-img');
        state.gImgBack = e.target.getAttribute('data-img2') || '';
        state.gcolorCss = '';
      } else {
        var sw = e.target.parentNode.querySelector('.fcq__sw');
        state.gcolorCss = sw ? sw.style.backgroundColor : '';
      }
      renderMock(); refreshSteps(); syncOut(); reveal('method');
      return;
    }
    if (n === 'fcq-method') {
      state.method = v;
      renderTextColors(); drawArt(); refreshSteps(); syncOut(); reveal('art');
      return;
    }
    if (n === 'fcq-mode') { state.mode = v; syncArtUI(); return; }
    if (n === 'fcq-font') { state.font = v; drawArt(); syncOut(); return; }
    if (n === 'fcq-tcolor') {
      state.tcolor = v;
      var s2 = e.target.parentNode.querySelector('.fcq__sw');
      state.tcolorCss = s2 ? s2.style.backgroundColor : '';
      drawArt(); syncOut();
      return;
    }
    if (n === 'fcq-spot') {
      state.spot = parseInt(v, 10) || 0;
      renderArtSizes(); renderMock(); syncOut();
      return;
    }
    if (n === 'fcq-artsize') { state.artSize = parseInt(v, 10) || 0; drawArt(); syncOut(); return; }
  });

  root.addEventListener('input', function (e) {
    if (e.target.hasAttribute('data-fcq-size')) {
      state.sizes[e.target.getAttribute('data-fcq-size')] = parseInt(e.target.value, 10) || 0;
      updateTotal(); refreshSteps(); syncOut();
      return;
    }
    if (e.target.hasAttribute('data-fcq-pieces')) {
      state.pieces = parseInt(e.target.value, 10) || 0;
      updateTotal(); refreshSteps(); syncOut();
      return;
    }
    if (e.target.hasAttribute('data-fcq-text')) {
      state.text = e.target.value;
      var c = q('[data-fcq-count]');
      if (c) c.textContent = state.text.length + ' / 40';
      root.querySelectorAll('[data-fcq-sample]').forEach(function (s) {
        s.textContent = state.text.trim() || 'Your Text';
      });
      drawArt(); refreshSteps(); syncOut();
    }
  });

  function syncArtUI() {
    var isLogo = state.mode === 'logo';
    var tf = q('[data-fcq-textwrap]');
    var ff = q('[data-fcq-fontwrap]');
    if (tf) tf.style.display = isLogo ? 'none' : '';
    if (ff) ff.style.display = isLogo ? 'none' : '';
    drawArt(); refreshSteps(); syncOut();
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      var missing = null;
      for (var i = 0; i < ORDER.length; i++) if (!done(ORDER[i])) { missing = ORDER[i]; break; }
      if (missing) {
        e.preventDefault();
        e.stopPropagation();
        var elx = q('[data-fcq-step="' + missing + '"]');
        if (elx) { elx.classList.add('is-missing'); elx.classList.add('is-open'); reveal(missing); }
        return;
      }
      syncOut();
    }, true);
  }

  window.addEventListener('resize', drawArt);

  // ---------- 시작 ----------
  var fromLink = applyLink();

  renderProducts();
  renderStyles();
  renderGarment();
  renderFonts();
  renderMethods();
  renderTextColors();
  renderSpots();
  renderArtSizes();
  renderQty();
  renderMock();
  refreshSteps();
  syncOut();

  if (fromLink) {
    var note = document.createElement('p');
    note.className = 'fcq__loaded';
    note.textContent = 'Loaded from a design link.';
    var stage = q('.fcq__stage');
    if (stage) stage.insertBefore(note, stage.firstChild);
    setTimeout(function () { reveal('product'); }, 120);
  }
})();